export default __webpack_public_path__ + "vans.946aebc72fd3989bf70108e92442400d.png";